import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { createTheme, ThemeProvider } from "@material-ui/core/styles";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import {
  Dialog,
  CircularProgress,
  DialogContent,
  useTheme,
} from "@mui/material"; //FB 7681
import DateFnsUtils from "@date-io/date-fns";
import { GetActivityLogs } from "../../../../api";
import useMediaQuery from "@mui/material/useMediaQuery";

// Update log
// FB  6192   02/06/2023  DK  Added page to display Activity logs
// FB  7681   03/04/2024  KI  Orady - need gear icon on mobile when the doc or any pages are loading



export default function ActivityLog() {
  const matches = useMediaQuery("(min-width:600px)");
  const JSAlert = require("js-alert");
  const [FromDate, setFromDate] = React.useState(null as unknown as Date);
  const [ToDate, setToDate] = React.useState(null as unknown as Date);
  const theme = createTheme({
    palette: {
      primary: {
        main: "#18a2b8",
      },
    },
  });
  const [ActivityLogsArray, setActivityLogsArray] = React.useState<
    Array<LogsProps>
  >([]);
  type LogsProps = {
    patientLogDate: Date;
    patientLogIP: string;
    patientLogPage: string;
    userName: string;
    transmitTo: string;
    transmitStatus: string;
  };
  const [check, setChecked] = React.useState(false);
  const [fnameError, setFnameError] = React.useState(false);
  const [tonameError, setTonameError] = React.useState(false);

  //FB 7681 start
  const [showSpinner, setShowSpinner] = React.useState(false);
  const themes = useTheme();
  //FB 7681 end

  const activityLogs = async () => {
    setShowSpinner(true);  //FB 7681
    const abc = new Date(FromDate);
    const FromDateValue = abc.toLocaleDateString("en-ZA");

    const def = new Date(ToDate);
    const ToDateValue = def.toLocaleDateString("en-ZA");

    var datalocal = sessionStorage.getItem("user");
    if (datalocal != null) {
      const user = JSON.parse(datalocal);
      if (FromDate == null || FromDate == undefined) {
        setFnameError(true);
      } else if (ToDate == null || ToDate == undefined) {
        setFnameError(false);
        setTonameError(true);
      } else if (user.Patient_n != null) {
        setTonameError(false);
        var data = await GetActivityLogs(
          user.Login,
          FromDateValue,
          ToDateValue
        );
        if (data.length == 0) {
          JSAlert.alert("No Data Found", null, JSAlert.Icons.Failed);
        }
        setChecked(true);

        setActivityLogsArray(data);
      }
      //FB 7681 - Begin
    setTimeout(() => {
      setShowSpinner(false);
    }, 5000);
    //FB 7681 - End
      console.log(ActivityLogsArray);
    }
  };
  return (
    <div
      style={{
        paddingLeft: matches == false ? "16px" : "80px",
        marginTop: "10px",
        paddingBottom: "20px",
      }}
    >
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <ThemeProvider theme={theme}>
          <KeyboardDatePicker
            InputLabelProps={{ shrink: true }}
            format="MM/dd/yyyy"
            label="From"
            style={keyboard.container}
            value={FromDate}
            error={fnameError}
            helperText={fnameError == true ? "Enter From Date" : ""}
            placeholder="MM/dd/yyyy"
            required
            disableFuture
            onChange={(newValue: any) => {
              setFromDate(newValue);
            }}
          />
        </ThemeProvider>
      </MuiPickersUtilsProvider>
      &nbsp;&nbsp;&nbsp;
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <ThemeProvider theme={theme}>
          <KeyboardDatePicker
            InputLabelProps={{ shrink: true }}
            format="MM/dd/yyyy"
            placeholder="MM/dd/yyyy"
            label="To"
            value={ToDate}
            error={tonameError}
            helperText={tonameError == true ? "Enter To Date" : ""}
            required
            disableFuture
            onChange={(newValue: any) => {
              setToDate(newValue);
            }}
          />
        </ThemeProvider>
      </MuiPickersUtilsProvider>
      &nbsp;&nbsp;&nbsp;&nbsp;
      <button
        className="btn"
        style={{
          backgroundColor: "#13607C",
          color: "white",
          marginTop: "12px",
        }}
        onClick={activityLogs}
      >
        Get Activity Logs
      </button>
      <br></br>
      {!check && <div style={{ minHeight: "400px" }}></div>}
      {!matches && (
        <label style={{ marginTop: "10px" }}>
          Swipe Right for more details
        </label>
      )}
      {check && (
        <div>
          <TableContainer component={Paper} style={{ marginTop: "20px" }}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>
                    <strong>Date</strong>
                  </TableCell>
                  <TableCell align="left">
                    <strong>Ip</strong>
                  </TableCell>
                  <TableCell align="left">
                    <strong>Action</strong>&nbsp;
                  </TableCell>
                  <TableCell align="left">
                    <strong>User</strong> &nbsp;
                  </TableCell>
                  <TableCell align="left">
                    <strong>Transmit To </strong>&nbsp;
                  </TableCell>
                  <TableCell align="left">
                    <strong>Transmit Status</strong>&nbsp;
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {ActivityLogsArray.map((x) => (
                  <TableRow
                    key={x.userName}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell align="left" style={{ minWidth: "240px" }}>
                      {new Date(x.patientLogDate)
                        .toLocaleDateString("en-US", {
                          year: "numeric",
                          month: "2-digit",
                          day: "2-digit",
                          hour: "2-digit",
                          minute: "2-digit",
                          second: "2-digit",
                        })
                        .replace(",", "")}
                    </TableCell>
                    <TableCell align="left">{x.patientLogIP}</TableCell>
                    <TableCell align="left">{x.patientLogPage}</TableCell>
                    <TableCell align="left">{x.userName}</TableCell>
                    <TableCell align="left">{x.transmitTo}</TableCell>
                    <TableCell align="left">{x.transmitStatus}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      )}
	  {/* FB 7681 - Begin */}
		<ThemeProvider theme={themes}>
          <Dialog open={showSpinner} fullWidth maxWidth={"xs"}>
            <DialogContent
              style={{
                display: "flex",
                alignContent: "center",
                justifyContent: "center",
              }}
            >
              <CircularProgress style={{ color: "#083A4D" }} />
            </DialogContent>
          </Dialog>
        </ThemeProvider>
	{/* FB 7681 - end */}
    </div>
  );
}
const keyboard = {
  container: {
    fontSize: "10px",
  },
};
